export const errorLogger = (e) => {
  if (process.env.NODE_ENV === 'development') {
    console.warn(e);
    console.warn('This message only for developers, please close inspect!!!');
  }
};
